<mat-form-field [class]="'form-field-cs icon-pick-field ' + fieldSize " >
	<mat-icon [class]="'base-icon icon-pick-field--icon  ' + fieldSize " [svgIcon]="formControlData?.value" ></mat-icon>
	<mat-select [formControl]="formControlData"
			[class]="'icon-pick-field--select  ' + fieldSize " disableRipple panelClass="nd-select-icon" 
			[placeholder]="'MODALS.FIELDS.ICON' | translate"  >
		<mat-option *ngFor="let item of iconSet" [value]="item">
			<mat-icon class="base-icon" [svgIcon]="item" ></mat-icon>
			<span [class]="'icon-pick-field--label ' + fieldSize "  >  {{ 'MODALS.FIELDS.ICON' | translate }} </span> 
		</mat-option>
	</mat-select>
</mat-form-field>